import { Component, OnInit, Input } from '@angular/core';
import { SocialService } from '@services/social.service';
import { GlobalService } from '@common/global';
@Component({
  selector: 'app-rating',
  templateUrl: './rating.component.html',
  styleUrls: ['./rating.component.sass']
})
export class RatingComponent implements OnInit {

  rate_readonly = false;
  @Input('res') response: object;
  @Input('c') component: string;
  @Input('a') application: string;
  @Input('className') className: string;
  @Input('media') media: string;
  rate = 0;
  constructor(private _socialService: SocialService, private _global: GlobalService) {

  }
  ngOnInit(): void {
  }

  rating(e) {
    if (this._global.isAuthenticated()) {
      this.rate = e;
      this.rate_readonly = true;
      let action = 'rate';
      let social = "averageRating";
      let p = {
        "component": this.component,
        "application": this.application,
        "entityId": this._global.getVal(this.response, 'id', ''),
        "action": action,
        "entityType": this.application,
        "actionDetails": this.rate
      };
      this._socialService.rating(p).subscribe(
        socialView => {
          if (socialView["status"] == "1") {
            this._global.showMessage({ "type": 'success', "message": this._global.getVal(socialView, 'response.message', '') });
            if (this.media) {
              this.response[social] = this._global.getVal(socialView, 'response.media.' + social, 0);
            } else {
              this.response[social] = this._global.getVal(socialView, 'response.' + this.application + '.' + social, 0);
            }
          } else {
            this._global.showMessage({ "type": 'warning', "message": this._global.getVal(socialView['errors'], 'danger', '') });
          }
        },
        error => {
          console.log("error", JSON.stringify(error));
        });
    } else {
      this._global.showMessage({ "type": 'info', "message": 'Please login first' });
    }
  }

}
